<template>
  <div v-on="$listeners"
       :style="containerStyle">
    <BeatLoader v-bind="loaderAttrs"
                :loading="loading" />
  </div>
</template>

<script>
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'LoaderPrimary',
    inheritAttrs: false,
    components: {
      BeatLoader,
    },
    props: {
      loading: { type: Boolean, required: false, default: true },
      size: { type: String, required: false, default: FontStyle.size.md },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        },
        loaderAttrs: {
          size: this.size,
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        ...this.$attrs,
      };

      this.loaderAttrs = {
        ...this.loaderAttrs,
        color: this.color.dark4(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };

</script>
